import { useGetIdentity } from "@refinedev/core";
import type { User } from "@supabase/supabase-js";

export const useIdentity = () => useGetIdentity<User>();
